import { Button } from 'react-aria-components/Button';
import { Dialog, DialogTrigger } from 'react-aria-components/Dialog';
import { Modal, ModalOverlay } from 'react-aria-components/Modal';

import { SearchTranslation } from '../../../../../app/localization/SiteTranslation';
import Icon from '../../../../../app/shared/components/Icon/Icon';
import SearchBar from '../../SearchBar/SearchBar';
import css from './Search.css';

interface SearchProps {
  isOpen: boolean;
  translation: SearchTranslation;
  onOpenChange: (isOpen: boolean) => void;
  onSearch: (query: string) => void;
}

export default function Search({ isOpen, translation, onOpenChange, onSearch }: SearchProps) {
  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
      <Button className={css.trigger}>
        <Icon className={css.icon} name="search" />
        {translation.openButton}
      </Button>
      <ModalOverlay className={css.overlay} isDismissable>
        <Modal className={css.modal}>
          <Dialog aria-label={translation.title}>
            <div className={css.container}>
              <div className={css.inner}>
                <SearchBar
                  className={css.searchBar}
                  autoFocus
                  translation={translation.searchBar}
                  onSearch={onSearch}
                />
                <Button slot="close" className={css.buttonClose} aria-label={translation.closeButton}>
                  <Icon className={css.icon} name="cross" />
                </Button>
              </div>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
}
